<template>
  <b-row class="m-0">
    <b-col class="border rounded p-3">
      <b-row>
        <b-col>
          <b-alert
            class="text-center"
            variant="success"
            v-model="showAlert"
            dismissible
          >
            <strong v-text="$lang.successfully_send_file" />
          </b-alert>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6" md="7" class="text-left">
          <img
            :src="image"
            class="img-thumbnail image_thumb"
            @error="errorImg"
          />
          <b-progress
            v-if="progressShow"
            :value="progress"
            show-progress
            :animated="progress == 100 ? false : true"
          >
          </b-progress>
        </b-col>
        <b-col cols="6" md="5">
          <b-button
            v-if="!image"
            class="
              mb-md-4 mb-2
              d-flex
              align-items-center
              justify-content-between
              position-relative
            "
            variant="outline-dark"
            block
          >
            <input
              ref="fileInput"
              id="fileInput"
              type="file"
              class="input-file"
              @change="onChange"
            />
            <span v-text="$lang.select_file" />
            <i class="fas fa-camera" />
          </b-button>
          <b-button
            v-else
            class="
              mb-md-4 mb-2
              d-flex
              align-items-center
              justify-content-between
            "
            variant="danger"
            block
            @click="removeImage"
          >
            <span v-text="$lang.file_deleted" />
            <i class="fas fa-times" />
          </b-button>
          <b-overlay
            :show="progressShow"
            spinner-small
            spinner-variant="primary"
          >
            <b-button
              block
              class="d-flex align-items-center justify-content-between"
              variant="primary"
              :disabled="!image"
              @click="personAttachment"
            >
              <span v-text="$lang.submit_file" />
              <i class="fa fa-check" />
            </b-button>
          </b-overlay>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-modal
            :title="modalTitle"
            header-bg-variant="danger"
            size="md"
            v-model="confirmModal"
          >
            <h6 v-text="message" />
            <template v-slot:modal-footer>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="cancelConfim"
              >
                {{ $lang.close }}
                <i class="fa fa-ban"></i>
              </b-button>
            </template>
          </b-modal>
          <confirm
            ok-only
            :title="modalTitle"
            :description="message"
            v-model="confirmModal"
            :ok-title="$lang.case_confirm"
            :cancel-title="$lang.case_confirm"
            @ok="okConfim"
          ></confirm>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import confirm from "@/components/base/confirm";
export default {
  name: "single_upload_component",
  data() {
    return {
      progress: 0,
      progressShow: false,
      confirmModal: false,
      modalTitle: "",
      message: "",
      files: null,
      image: "",
      showAlert: false,
    };
  },
  components: {
    confirm,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    image_id: {
      type: [Number, String],
    },
  },
  methods: {
    clearValue() {
      document.getElementById("fileInput").value = "";
    },
    clearModalConfirm() {
      this.modalTitle = "";
      this.message = "";
      this.removingItemId = null;
    },
    async okConfim() {
      if (this.image_id && this.mode == "delete") {
        try {
          let url =
            this.$config.api_url +
            this.$config.resources.person_attachment.replace(
              "{0}",
              this.data.attachmentId
            ) +
            `/${this.image_id}`;
          const response = await this.$httpService.delete(url);
          this.$emit("getImageProfile");
        } catch (error) {
          this.$generateError(error);
        }
      } else {
        this.mode = "";
        this.clearValue();
      }
    },
    cancelConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    async deleteImage() {
      // this.removingItemId = this.image_id;
      this.mode = "delete";
      this.message = this.$lang.are_you_sure_to_remove_item.replace(
        "{item}",
        this.$lang.profile_image
      );
      this.modalTitle = this.$lang.remove_item;
      this.confirmModal = true;
    },
    errorImg(e) {
      if (e.type == "error") {
        e.target.src = this.$config.images.shared.noImage;
      }
    },
    bytesToSize(bytes) {
      const sizes = ["بایت", "کیلوبایت", "مگابایت", "گیگابایت"];
      if (bytes == 0) return "0 Byte";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    onChange(e) {
      this.files = e.target.files[0];
      const LIMIT_SIZE = 1050000;
      if (this.files.size > LIMIT_SIZE) {
        this.message =
          this.$lang.imgVolume.replace("{0}", this.bytesToSize(LIMIT_SIZE)) +
          " " +
          this.$lang.fileVolumeSize.replace(
            "{0}",
            this.bytesToSize(this.files.size)
          );
        this.modalTitle = this.$lang.warning;
        this.confirmModal = true;
        this.dragging = false;
        return;
      }
      this.createImage();
    },
    createImage() {
      const reader = new FileReader();
      const vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(vm.files);
    },
    removeImage() {
      this.image = "";
    },
    async personAttachment() {
      try {
        this.progressShow = true;
        let url =
          this.$config.api_url +
          this.$config.resources.attachment_wot
            .replace("{0}", this.data.keyServies)
            .replace("{1}", this.data.attachmentId);
        let formData = new FormData();
        formData.append("file", this.files);
        formData.append("caption", this.data.caption);
        formData.append("attachment_type_id", this.data.attachment_type_id);
        formData.append("attachment_type_name", "attachment_type_ticket");
        formData.append("resize_avatar", false);
        const response = await this.$httpService.post(
          url,
          formData,
          {
            "Content-Type": "multipart/form-data",
          },
          true,
          {
            onUploadProgress: function (e) {
              this.progress = parseInt(Math.round((e.loaded * 100) / e.total));
            }.bind(this),
          }
        );
        this.$notify.success(response.data.message);
        this.$emit("done");
        this.showAlert = true;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.progressShow = false;
        this.removeImage();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.image_thumb {
  width: 100%;
  height: 100px;
}
@media (max-width: 575.98px) {
  .image_thumb {
    height: 85px;
  }
}

.input-file {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
</style>
